import { Component, Input, OnInit } from '@angular/core';
import { FormWizardPageElement } from 'src/app/models/form-wizard-template.model';
import * as _ from 'lodash';
import { ControlContainer, NgForm } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-checkbox-element',
  templateUrl: './checkbox-element.component.html',
  styleUrls: ['./checkbox-element.component.scss'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class CheckboxElementComponent implements OnInit {
  @Input() element: FormWizardPageElement | undefined;
  @Input() formValues: any | undefined;
  public testValue = false;
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }

  public getControlName(): string {
    return 'input' + this.getName();
  }

  public getName(): string {
    return this.element?.name ?? '';
  }

  public getLabelHtml(): any {
    const html = `<label class="k-label" ng-reflect-for="${this.getControlName()}" for="${this.getControlName()}">${this.element?.label ?? ''}</label>`
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  public isLabelVisible(): boolean {
    return this.getLabelHtml() !== '' && this.isControlVisible();
  }

  public isControlVisible(): boolean {
    return !_.isNil(this.element) && !_.isNil(this.formValues);
  }

  public isRequired(): boolean {
    return this.element?.required ?? false;
  }
}
